export default __webpack_public_path__ + "static/media/home.53f21732.svg";